import type { ChartId } from 'charts/catalog/chartCatalog';
import { SmallChartCard } from 'charts/common/SmallChartCard';
import type { ComponentProps, ReactElement } from 'react';
import { useChartSectionFilters } from '../sectionFilters/SectionFiltersContext';

type SectionChartCardProps = Omit<
  ComponentProps<typeof SmallChartCard>,
  'hasCustomFilters' | 'onRestoreSectionFilters'
> &
  Readonly<{ chartId: ChartId }>;

/** A chart tile of a dashboard section: shows when the chart has its own filters and gives it the section's back. */
export function SectionChartCard(props: SectionChartCardProps): ReactElement {
  const { hasCustomFilters, restoreSectionFilters } = useChartSectionFilters(props.chartId);
  return (
    <SmallChartCard {...props} hasCustomFilters={hasCustomFilters} onRestoreSectionFilters={restoreSectionFilters} />
  );
}
